/**
 * Что мини-апп шлёт в Метрику — в одном месте.
 *
 * Имена читают код, `docs/analytics.md` и отчёты Метрики. Имя, однажды
 * уехавшее на прод, менять нельзя: переименование рвёт исторические
 * отчёты. Нужно другое — заводится новое.
 *
 * Разделение на `EVENT` и `VIEW` повторяет разделение самой Метрики.
 * `EVENT` — цели, считаются по визитам (уникально). `VIEW` — просмотры,
 * считаются неуникально. ТЗ просит у одних показателей уникальность,
 * у других нет, и перепутать их значит молча посчитать не то.
 */

/** Цели: уникальные за визит. */
export const EVENT = {
  /** Уник. клики «Подпишись на канал» — пункт ТЗ. */
  subscribeClicked: 'subscribe_clicked',
  /** Вход опознанного игрока: нужен, чтобы привязать `userParams`. */
  appOpened: 'app_opened',
} as const;

export type AppEvent = (typeof EVENT)[keyof typeof EVENT];

/**
 * Экран для просмотра.
 *
 * Это НЕ путь роутера: пути — деталь реализации и могут поменяться,
 * а имя экрана в отчёте должно пережить рефакторинг маршрутов.
 */
export type ScreenName =
  'home' | 'matches' | 'derby' | 'career' | 'draws' | 'rating' | 'profile';

/**
 * Синтетические пути для того, что страницей не является.
 *
 * Модальное окно подписки, открытие Дрибла и клик по его результатам
 * маршрута не имеют, но в ТЗ у них стоит НЕуникальный счёт — а неуникально
 * Метрика считает только просмотры. Префикс `/e/` отделяет их от настоящих
 * экранов, чтобы «заходы в Главную» не смешались с показами окна.
 */
export const VIEW = {
  /** Приложение открыто. Шлётся до авторизации — см. `initAnalytics`. */
  launch: '/e/launch',
  screen: (screen: ScreenName) => `/${screen}`,
  subscribeScreen: '/e/subscribe-screen',
  derbyOpened: (derbyId: string) => `/e/derby/${derbyId}`,
  derbyResultClicked: '/e/derby-result',
} as const;
